import { render, staticRenderFns } from "./Gastos.vue?vue&type=template&id=7fbefdf4&scoped=true"
import script from "./Gastos.vue?vue&type=script&lang=js"
export * from "./Gastos.vue?vue&type=script&lang=js"
import style0 from "./Gastos.vue?vue&type=style&index=0&id=7fbefdf4&prod&lang=scss"
import style1 from "./Gastos.vue?vue&type=style&index=1&id=7fbefdf4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbefdf4",
  null
  
)

export default component.exports